/**
 * 等级装扮
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message, Carousel } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import IntimateAffinityCard from './components/IntimateAffinityCard';
import Util from '../../script/util';

class LevelDress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      detail: null,
      searchUid: null,
      intimateRelationId: null,
      tab: 1,
      swiperIndex: 0,
    };
  }

  showModal = (data) => {
    const { searchUid, intimateRelationId } = data;
    this.setState(
      {
        searchUid,
        intimateRelationId,
      },
      () => {
        this.getAffinitySpaceDressInfo();
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  onChangeTab = (tab) => {
    this.setState(
      {
        tab,
        swiperIndex: 0,
      },
      () => {
        this.getAffinitySpaceDressInfo();
      }
    );
  };

  //获取亲密空间等级装扮信息
  getAffinitySpaceDressInfo = () => {
    const { searchUid, intimateRelationId, tab } = this.state;
    let params = {
      searchUid,
      intimateRelationId,
      type: tab,
    };
    HTTP._get_affinity_space_dress_info(params).then((res) => {
      if (res.code == 200) {
        this.setState({ detail: res.data || {}, visible: true });
      } else {
        message.error(res.message);
      }
    });
  };

  onSave = () => {
    this.setState({ visible: false });
  };

  onCarouselPrev = () => {
    this.carouselRef.prev();
    setTimeout(() => {
      let index = this.carouselRef.innerSlider.state.currentSlide;
      this.setState({
        swiperIndex: index,
      });
    }, 10);
  };
  onCarouselNext = () => {
    this.carouselRef.next();
    setTimeout(() => {
      let index = this.carouselRef.innerSlider.state.currentSlide;
      this.setState({
        swiperIndex: index,
      });
    }, 10);
  };
  onCarouselGoTo = (index) => {
    this.carouselRef.goTo(index);
    this.setState({
      swiperIndex: index,
    });
  };

  renderNextArrow = () => {
    const { detail, swiperIndex, tab } = this.state;
    let swiperList =
      detail?.[['connectMic', 'relationUser', 'animationMic'][tab - 1]];
    if (!swiperList?.length) return null;
    return swiperIndex != swiperList.length - 1 ? (
      <div
        className="affinity-space-carousel-next"
        onClick={this.onCarouselNext}
      ></div>
    ) : null;
  };

  render() {
    const { loading, tab, detail, swiperIndex, visible } = this.state;
    if (!detail) return '';
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border affinity-space bg0"
          zIndex={1003}
          centered={true}
          title={`等级装扮`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <Scrollbar
              ref={(el) => (this.scrollElement = el)}
              className="my-scroll-bar"
              style={{ height: '620px' }}
            >
              <div className="affinity-space-box" style={{ padding: 0 }}>
                <div className="affinity-space-tab">
                  <div
                    className={`affinity-space-tab-item ${tab == 1 ? 'active' : ''}`}
                    onClick={() => this.onChangeTab(1)}
                  >
                    麦位连线
                  </div>
                  <div
                    className={`affinity-space-tab-item ${tab == 2 ? 'active' : ''}`}
                    onClick={() => this.onChangeTab(2)}
                  >
                    关系卡片
                  </div>
                  <div
                    className={`affinity-space-tab-item ${tab == 3 ? 'active' : ''}`}
                    onClick={() => this.onChangeTab(3)}
                  >
                    上麦动效
                  </div>
                </div>
                <div className="affinity-space-carousel">
                  {swiperIndex != 0 ? (
                    <div
                      className="affinity-space-carousel-prev"
                      onClick={this.onCarouselPrev}
                    ></div>
                  ) : null}
                  <Carousel
                    className="affinity-space-carousel-content"
                    ref={(el) => (this.carouselRef = el)}
                    infinite={false}
                    accessibility={false}
                    dots={false}
                  >
                    {tab == 1
                      ? detail?.connectMic?.map((item, index) => (
                          <div
                            className="affinity-space-carousel-item"
                            key={index}
                          >
                            <div className="affinity-space-carousel-item-line">
                              <div className="affinity-space-carousel-item-avatar">
                                <div className="affinity-space-carousel-item-mic">
                                  {detail?.searchMicImage ? (
                                    <img
                                      src={Util.transImgUrl(
                                        detail?.searchMicImage,
                                        '150x150'
                                      )}
                                      alt=""
                                    />
                                  ) : null}
                                </div>
                                <div className="affinity-space-carousel-item-cover">
                                  <img
                                    src={Util.transImgUrl(
                                      detail?.searchAvatar,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="affinity-space-carousel-item-center">
                                <img
                                  src={Util.transImgUrl(
                                    item.levelIcon,
                                    '150x150'
                                  )}
                                  alt=""
                                />
                              </div>
                              <div className="affinity-space-carousel-item-avatar">
                                <div className="affinity-space-carousel-item-mic">
                                  {detail?.otherMicImage ? (
                                    <img
                                      src={Util.transImgUrl(
                                        detail?.otherMicImage,
                                        '150x150'
                                      )}
                                      alt=""
                                    />
                                  ) : null}
                                </div>
                                <div className="affinity-space-carousel-item-cover">
                                  <img
                                    src={Util.transImgUrl(
                                      detail?.otherAvatar,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                    {tab == 2
                      ? detail?.relationUser?.map((item, index) => (
                          <div
                            className="affinity-space-carousel-item"
                            key={index}
                          >
                            <div
                              className="intimate-affinity-box"
                              style={{
                                height: '148px',
                                justifyContent: 'center',
                              }}
                            >
                              <IntimateAffinityCard
                                key={item.intimateRelationId}
                                data={{
                                  ...detail,
                                  level: item?.levelCurrent,
                                  relCardIcon: item?.levelIcon,
                                }}
                              />
                            </div>
                          </div>
                        ))
                      : null}
                    {tab == 3
                      ? detail?.animationMic?.map((item, index) => (
                          <div
                            className="affinity-space-carousel-item"
                            key={index}
                          >
                            <div className="affinity-space-carousel-item-line">
                              <div className="affinity-space-carousel-item-avatar">
                                <div className="affinity-space-carousel-item-mic">
                                  {detail?.searchMicImage ? (
                                    <img
                                      src={Util.transImgUrl(
                                        detail?.searchMicImage,
                                        '150x150'
                                      )}
                                      alt=""
                                    />
                                  ) : null}
                                </div>
                                <div className="affinity-space-carousel-item-cover">
                                  <img
                                    src={Util.transImgUrl(
                                      detail?.searchAvatar,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                                <div className="affinity-space-carousel-item-effect">
                                  <img
                                    src={Util.transImgUrl(
                                      item?.levelIcon,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="affinity-space-carousel-item-center"></div>
                              <div className="affinity-space-carousel-item-avatar">
                                <div className="affinity-space-carousel-item-mic">
                                  {detail?.otherMicImage ? (
                                    <img
                                      src={Util.transImgUrl(
                                        detail?.otherMicImage,
                                        '150x150'
                                      )}
                                      alt=""
                                    />
                                  ) : null}
                                </div>
                                <div className="affinity-space-carousel-item-cover">
                                  <img
                                    src={Util.transImgUrl(
                                      detail?.otherAvatar,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                                <div className="affinity-space-carousel-item-effect">
                                  <img
                                    src={Util.transImgUrl(
                                      item?.levelIcon,
                                      '150x150'
                                    )}
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                  </Carousel>
                  {this.renderNextArrow()}
                </div>
                <div className="affinity-space-swiper">
                  <div
                    className="affinity-space-swiper-box"
                    style={{
                      '--var-slide':
                        swiperIndex > 2
                          ? 2
                          : swiperIndex < 2
                            ? 0
                            : swiperIndex - 1,
                    }}
                  >
                    {detail &&
                      detail[
                        ['connectMic', 'relationUser', 'animationMic'][tab - 1]
                      ]?.map((item, index) => (
                        <div
                          key={index}
                          className={`affinity-space-swiper-item ${swiperIndex == index ? 'active' : ''}`}
                          onClick={() => this.onCarouselGoTo(index)}
                        >
                          <div className="affinity-space-swiper-cover">
                            <img
                              src={Util.transImgUrl(item.levelIcon)}
                              alt=""
                            />
                          </div>
                          <div className="affinity-space-swiper-level">
                            {item.levelDesc}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Scrollbar>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(LevelDress, { withRef: true })
);
